"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = Badge;
const jsx_runtime_1 = require("react/jsx-runtime");
const class_variance_authority_1 = require("class-variance-authority");
const utilities_1 = require("../../utilities");
const BadgeVariants = (0, class_variance_authority_1.cva)("ko:flex ko:gap-1.5 ko:items-center ko:px-1.5 ko:border ko:w-fit ko:rounded-sm ko:text-xs ko:[&>svg]:opacity-70", {
    variants: {
        color: {
            primary: "ko:bg-primary/8 ko:text-primary ko:border-transparent",
            secondary: "ko:bg-secondary/8 ko:text-secondary ko:border-transparent",
            yellow: "ko:bg-yellow/8 ko:text-yellow ko:border-transparent",
            green: "ko:bg-green/8 ko:text-green ko:border-transparent",
            neutral: "ko:bg-neutral/8 ko:text-neutral ko:border-transparent",
            transparent: "ko:border ko:text-neutral ko:border-neutral/10",
        },
    },
    defaultVariants: {
        color: "primary",
    },
});
function Badge({ children, color }) {
    return (0, jsx_runtime_1.jsx)("div", { className: (0, utilities_1.twMerge)(BadgeVariants({ color })), children: children });
}
